import React from 'react';
import {
  Form,
  Card,
  Typography,
  Spin,
  Alert
} from 'antd';
import { FormOutlined } from '@ant-design/icons';
import moment from 'moment';
import FormFieldRenderer from '../../../pages/EventManagement/FormFieldRenderer';

const { Text } = Typography;

const Step3CustomForms = ({
  loadingForms,
  customForms,
  formsForm,
  formResponses,
  setFormResponses,
  formValues,
  selectedDate,
  selectedTimeSlot
}) => {
  if (loadingForms) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px', color: '#8c8c8c' }}>Loading forms...</div>
      </div>
    );
  }

  if (!customForms || customForms.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Alert 
          message="No forms found" 
          description="This event type does not have any associated forms."
          type="info"
          showIcon
        />
      </div>
    );
  }

  const currentForm = customForms[0]; // For now, show first form (can add multi-form navigation later)

  return (
    <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '8px' }}>
      <Alert
        message="Additional Information Required"
        description="Please complete the following form to finalize the booking."
        type="info"
        showIcon
        icon={<FormOutlined />}
        style={{ marginBottom: '16px' }}
      />

      {currentForm && (
        <Form form={formsForm} layout="vertical">
          <div style={{ marginBottom: '16px' }}>
            <Text strong style={{ fontSize: '16px' }}>{currentForm.title}</Text>
            {currentForm.description && (
              <div style={{ color: '#8c8c8c', fontSize: '13px', marginTop: '4px' }}>
                {currentForm.description}
              </div>
            )}
          </div>

          {currentForm.fields && currentForm.fields.map((field, index) => (
            <FormFieldRenderer
              key={field._id || index}
              field={field}
              value={formResponses[currentForm._id]?.[field._id]}
              onChange={(value) => {
                setFormResponses(prev => ({
                  ...prev,
                  [currentForm._id]: {
                    ...(prev[currentForm._id] || {}),
                    [field._id]: value
                  }
                }));
              }}
            />
          ))}
        </Form>
      )}

      {/* Booking Summary */}
      <Card size="small" style={{ background: '#f5f5f5', marginTop: '24px' }}>
        <Text strong>Booking Summary</Text>
        <div style={{ marginTop: '8px' }}>
          <div><Text type="secondary">Client:</Text> {formValues?.firstName} {formValues?.lastName}</div>
          <div><Text type="secondary">Event:</Text> {formValues?.eventName || 'Not specified'}</div>
          <div><Text type="secondary">Date:</Text> {selectedDate?.format('MMMM D, YYYY')}</div>
          <div><Text type="secondary">Time:</Text> {moment(selectedTimeSlot?.startTime).format('h:mm A')}</div>
        </div>
      </Card>
    </div>
  );
};

export default Step3CustomForms;
